import { render } from "./companyBranch.vue?vue&type=template&id=22755bfa&scoped=true"
import script from "./companyBranch.vue?vue&type=script&lang=js"
export * from "./companyBranch.vue?vue&type=script&lang=js"

import "./companyBranch.vue?vue&type=style&index=0&id=22755bfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22755bfa"]])

export default __exports__